import { render, staticRenderFns } from "./IconFiles.vue?vue&type=template&id=b42ffa0e"
import script from "./IconFiles.vue?vue&type=script&lang=js"
export * from "./IconFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports